import { FILTERS } from "../types/filter.type";

const initialState = {
  loading: true,
  data: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FILTERS.SUCCESS_FETCH:
      return {
        loading: false,
        data: action.payload,
        error: "",
      };
    case FILTERS.FAIL_FETCH:
      return {
        loading: false,
        data: [],
        error: action.payload,
      };
    default:
      return { ...state };
  }
};
export default reducer;
